import React, { useEffect, useState, useContext } from "react";
import "./loginsignup.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash, faPhone, faLock } from "@fortawesome/free-solid-svg-icons";
import { AuthContext } from "../../context/Authcontext"; // adjust path

const Login = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const { login } = useContext(AuthContext);

  const navigate = useNavigate();
  const API_URL = process.env.REACT_APP_API_URL;

  const togglePassword = () => {
    setShowPassword(!showPassword);
  };

  // Optional: OTP Login handler if you plan to enable it
  useEffect(() => {
    // Only register callback if OTP login is enabled
    if (!window.phoneEmailReceiver) {
      window.phoneEmailReceiver = async (userObj) => {
        if (!userObj?.user_json_url) return;
        try {
          const res = await axios.post(`${API_URL}/user/login-otp`, {
            user_json_url: userObj.user_json_url,
          });

          if (res.data.success) {
            sessionStorage.setItem("token", res.data.token);
            sessionStorage.setItem("uniqueCode", res.data.uniqueCode);
            sessionStorage.setItem("user", JSON.stringify(res.data.user));

            login(res.data.user);
            navigate("/home");
          } else {
            setMessage(res.data.message || "OTP login failed");
          }
        } catch (err) {
          console.error("OTP Login Error:", err);
          setMessage("Something went wrong during OTP login");
        }
      };
    }

    // Cleanup
    return () => {
      delete window.phoneEmailReceiver;
    };
  }, [API_URL, navigate, login]);

  // Normal phone/password login
  const handleLogin = async () => {
    if (!phone || !password) return;

    try {
      const res = await axios.post(`${API_URL}/user/login`, { phone, password });

      if (res.data.success) {
        sessionStorage.setItem("token", res.data.token);
        sessionStorage.setItem("uniqueCode", res.data.uniqueCode);
        sessionStorage.setItem("user", JSON.stringify(res.data.user));
          window.dispatchEvent(new CustomEvent("userUpdated"));
        
        login(res.data.user); // update context
        navigate("/home");
      } else {
        setMessage(res.data.message || "Login failed");
      }
    } catch (err) {
      console.error("Login Error:", err);
      setMessage("Something went wrong during login");
    }
  };

  return (
    <div className="login-page">
      <div className="container">
        <div className="header">
          <div className="text">Login</div>
          <div className="underline"></div>
        </div>

        <div className="inputs">
          {/* Phone Input */}
          <div className="input">
            <FontAwesomeIcon icon={faPhone} className="icon" style={{ color: "blue" }} />
            <input
              type="tel"
              name="phone"
              placeholder="Phone number"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />
          </div>

          {/* Password Input */}
          <div className="input password-input">
            <FontAwesomeIcon icon={faLock} className="icon" style={{ color: "blue" }} />
            <input
              type={showPassword ? "text" : "password"}
              name="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <FontAwesomeIcon
              icon={showPassword ? faEyeSlash : faEye}
              className="eye-icon"
              onClick={togglePassword}
            />
          </div>
        </div>

        {message && <p className="message">{message}</p>}

        <div className="submit-container">
          <div
            className={`submit ${!phone || !password ? "disabled" : ""}`}
            onClick={(!phone || !password) ? null : handleLogin}
          >
            Login with Password
          </div>
        </div>

        {/* Optional OTP login section */}
        {/*
        <div className="submit-container">
          <p style={{ margin: "10px 0", fontWeight: "bold" }}>OR</p>
          <div className="pe_verify_email" data-client-id="13817304853595826940"></div>
        </div>
        */}
      </div>
    </div>
  );
};

export default Login;
